import { useEffect, useRef, useState } from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';
import Newsletter from './Newsletter';

export default function DeferredNewsletter() {
  const anchorRef = useRef<HTMLDivElement>(null);
  const nearViewport = useInViewOnce(anchorRef, { once: true, margin: '240px' });
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (nearViewport) setShow(true);
  }, [nearViewport]);

  return (
    <div ref={anchorRef} className="deferred-newsletter-wrapper">
      {show ? (
        <Newsletter />
      ) : (
        <div style={{ minHeight: '300px' }} aria-hidden="true" />
      )}
    </div>
  );
}

